import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import category from '../../data/jobs/category.json';

class Breadcrumbs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: ''
        };
    }
    // Search Filter
    onChange(event) {
        this.setState({ searchText: event.target.value })
    }
    handleSubmit(e) {
        e.preventDefault();
        //const { history } = this.props;
        if (this.state.searchText === "") {
            return;
        } else {
            this.props.history.push("/jobs/search/" + this.state.searchText);
        }
    }
    render() {
        return (
            <Fragment>
                <div className="subheader normal-bg section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="text-custom-white">
                                    <span>
                                        {this.props.breadcrumb.pagename}
                                    </span>
                                </h1>
                                <ul className="custom-flex justify-content-center">
                                    <li className="fw-500">
                                        <Link to="/" className="text-custom-white">Home</Link>
                                    </li>
                                    <li className="active fw-500">
                                        {this.props.breadcrumb.pagename}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fub-form">
                    <div className="container">
                        <div className="form-1">
                            <form className="row" onSubmit={this.handleSubmit.bind(this)} method="Post">
                                <div className="col-lg-3 col-md-6">
                                    <div className="mb-md-30">
                                        <div className="form-group">
                                            <input type="search" className="form-control form-control-custom" placeholder="Search keywords" name="searchText" value={this.state.searchText} onChange={this.onChange.bind(this)} required />
                                            <label style={{ color: '#aaaaaa', fontSize: '11px' }}>Search keywords e.g. web design</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="group-form mb-md-30">
                                        <div className="custom-select form-control form-control-custom nice-select mb-0">
                                            <select>
                                                {category.map((cat, i) => (
                                                    <option value={cat.title} key={i}>{cat.title}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <label style={{ color: '#aaaaaa', fontSize: '11px' }}>Filter by specialisms e.g. developer,
                                            designer</label>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="mb-sm-30">
                                        <div className="form-group">
                                            <input type="text" name="#" className="form-control form-control-custom" placeholder="All Location" required />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <button type="submit" className="btn-first btn-second">Find Jobs</button>
                                    <label style={{ color: '#aaaaaa', fontSize: '11px' }}>+ Advance Search</label>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withRouter(Breadcrumbs);